<template>
        <list v-if="insurances.length > 0">
            <list-item class="text-base sm:text-xl" v-for="insurance in insurances" :key="insurance.id"
                       :url="documentUrl(insurance.id)" target="_blank">
                <template slot="link-icon">
                    <span class="text-blue"><icon icon="far fa-arrow-circle-right" classes="w-8 h-8"></icon></span>
                </template>
                <template slot="icon">
                    <i class="text-blue text-xl fal fa-newspaper"></i>
                </template>
                <template slot="title">
                    {{insurance.title}}
                </template>
                <template slot="sub-title">
                    <span class="text-xs">
                        {{insurance.insurance_category}}
                    </span>
                    <span class="text-xs font-bold">
                        {{insurance.type}}
                    </span>
                </template>
            </list-item>
        </list>
</template>

<script>
    import auth from '../../auth';
    import {mapState} from "vuex";

    export default {
        props:['insurances'],

        computed:{
            ...mapState(['employee']),

            employeeID() {
                if (this.employee !== null) {
                    return this.employee.id
                }

                return '';
            },
        },

        methods: {
            documentUrl(id) {
                return `${process.env.VUE_APP_PORTAL}/api/hr/employee/${this.employeeID}/documents/insurances/${id}/view?api_token=${auth.getToken()}&timestamp=${(new Date()).getTime()}`;
            }
        },
    }
</script>
